module.exports = __webpack_public_path__ + "static/media/UN-17.3f041c45.jpg";